import { render, staticRenderFns } from "./UserProfileSkills.vue?vue&type=template&id=0b46b151&"
import script from "./UserProfileSkills.vue?vue&type=script&lang=js&"
export * from "./UserProfileSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports